module.exports = __webpack_public_path__ + "static/media/ImportIllustration.e937aedc.svg";